import { useContext } from "react";

import ProposalInputContext from "../../../context/ProposalInputContext";

import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import InputAdornment from '@mui/material/InputAdornment';
import FormControl from "@mui/material/FormControl";
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';

import AutoGraphOutlinedIcon from '@mui/icons-material/AutoGraphOutlined';

import ExpandableSectionHeader from "./ExpandableSectionHeader";

const OpportunityInfoForm = () => {
  const {
    values, setValues, formErrors, collapseValues,
    setCollapseValue, sectionStyle, marketAreaArray
  } = useContext(ProposalInputContext);

  return (
    <Grid container spacing={2} sx={sectionStyle}>
      <ExpandableSectionHeader
        sectionTitle='5. Opportunity Information'
        showSection='showOpportunityInfo'
        icon={<AutoGraphOutlinedIcon sx={{ color: "text.secondary" }} />}
        collapseValues={collapseValues}
        setCollapseValue={setCollapseValue}
      />

      {collapseValues?.showOpportunityInfo &&
        <>
          <Grid size={{ xs: 6 }}>
            <FormControl fullWidth error={'market' in formErrors}>
              <InputLabel id="market">Market area *</InputLabel>
              <Select
                labelId="market"
                id="market"
                name="market"
                value={values?.market}
                label="Market area *"
                onChange={e =>
                  setValues(prev => ({
                    ...prev,
                    market: e.target.value
                  }))
                }
              >
                {marketAreaArray.map((market, index) => (
                  <MenuItem value={market} key={index}>
                    {market}
                  </MenuItem>
                ))}
              </Select>
              <FormHelperText>{formErrors['market']}</FormHelperText>
            </FormControl>
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Number of work packages required *"
              name='numWorkPackages'
              value={values?.numWorkPackages}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  numWorkPackages: e.target.value
                }))
              }
              helperText={formErrors['numWorkPackages']}
              error={'numWorkPackages' in formErrors}
              type='number'
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Initial estimate of project cost *"
              name='overallPrice'
              value={values?.overallPrice}
              slotProps={{
                input: {
                  startAdornment: <InputAdornment position="start">£</InputAdornment>,
                },
              }}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  overallPrice: e.target.value
                }))
              }
              helperText={formErrors['overallPrice']}
              error={'overallPrice' in formErrors}
              type='number'
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Estimate duration in months *"
              name='projectDuration'
              value={values?.projectDuration}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  projectDuration: e.target.value
                }))
              }
              helperText={formErrors['projectDuration']}
              error={'projectDuration' in formErrors}
              type='number'
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Company website-url *"
              name='companyUrl'
              value={values?.companyUrl}
              slotProps={{
                input: {
                  startAdornment: <InputAdornment position="end">https://</InputAdornment>,
                },
              }}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  companyUrl: e.target.value
                }))
              }
              helperText={formErrors['companyUrl']}
              error={'companyUrl' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Objectives and goals"
              name='opportunityObjectives'
              value={values?.opportunityObjectives}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  opportunityObjectives: e.target.value
                }))
              }
              helperText={formErrors['opportunityObjectives']}
              error={'opportunityObjectives' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Assumptions"
              name='assumptions'
              value={values?.assumptions}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  assumptions: e.target.value
                }))
              }
              helperText={formErrors['assumptions']}
              error={'assumptions' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 6 }}>
            <TextField
              variant="outlined"
              label="Out of scope items"
              name='outOfScopeItems'
              value={values?.outOfScopeItems}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  outOfScopeItems: e.target.value
                }))
              }
              helperText={formErrors['outOfScopeItems']}
              error={'outOfScopeItems' in formErrors}
              fullWidth
            />
          </Grid>

          <Grid size={{ xs: 12 }}>
            <TextField
              variant="outlined"
              label="Opportunity details.......*"
              name='opportunityDetails'
              value={values?.opportunityDetails}
              onChange={e =>
                setValues(prev => ({
                  ...prev,
                  opportunityDetails: e.target.value
                }))
              }
              helperText={formErrors['opportunityDetails']}
              error={'opportunityDetails' in formErrors}
              multiline
              rows={10}
              fullWidth
              sx={{
                '& textarea': {
                  resize: 'vertical'
                }
              }}
            />
          </Grid>
        </>
      }
    </Grid>
  );
};

export default OpportunityInfoForm;